<template>
  <div class="space-y-10 divide-y divide-gray-900/10">
    <div class="grid grid-cols-1 gap-x-8 gap-y-8 pt-10 md:grid-cols-3">
      <div class="px-4 sm:px-0">
        <h2 class="text-base font-semibold leading-7 text-gray-900">User</h2>
        <p class="mt-1 text-sm leading-6 text-gray-600">User Text Prompt</p>
      </div>

      <Form v-slot="{ handleSubmit, errors}" :validation-schema="schema" class="bg-white shadow-sm ring-1 ring-gray-900/5 sm:rounded-xl md:col-span-2">
        <button v-if="userId" @click="destroy" type="button" class="rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600 m-3">
          <TrashIcon class="h-5 w-5" aria-hidden="true" />
        </button>
        <div class="px-4 py-6 sm:p-8">
          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

            <div class="sm:col-span-5">
              <label for="title" class="block text-sm font-medium leading-6 text-gray-900">
                First Name
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field v-model="formData.first_name" v-bind:class="{ 'ring-red-600': errors.first_name }" type="text" name="first_name" id="first_name" placeholder="First Name" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="first_name" />
              </div>
            </div>

            <div class="sm:col-span-5">
              <label for="website" class="block text-sm font-medium leading-6 text-gray-900">
                Last Name
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field v-model="formData.last_name" v-bind:class="{ 'ring-red-600': errors.last_name }" type="text" name="last_name" id="last_name" placeholder="Last Name" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="last_name" />
              </div>
            </div>
            <div class="sm:col-span-5">
              <label for="website" class="block text-sm font-medium leading-6 text-gray-900">
                Email
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field v-model="formData.email" v-bind:class="{ 'ring-red-600': errors.email }" type="text" name="email" id="email" placeholder="Email" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="email" />
              </div>
            </div>

            <div class="sm:col-span-5">
              <label for="profile_photo" class="block text-sm font-medium leading-6 text-gray-900">
                Profile Photo
              </label>
              <div class="mt-2 flex items-center space-x-4">

                <img v-if="previewImage" :src="previewImage" alt="Profile Photo" class="h-16 w-16 rounded-full">

                <button @click="selectProfilePhoto" type="button" class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">
                  Select Profile Photo
                </button>

                <input type="file" ref="profilePhotoInput" @change="handleProfilePhotoChange" accept="image/*" class="hidden">
              </div>
            </div>

            <div class="sm:col-span-5">
              <label for="website" class="block text-sm font-medium leading-6 text-gray-900">
                Password
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field v-model="formData.password" v-bind:class="{ 'ring-red-600': errors.password }" type="password" name="password" id="password" placeholder="Password" class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6" />
                <ErrorMessage class="mt-2 text-xs text-red-600" name="password" />
              </div>
            </div>
          </div>

          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mt-12" v-if="isAdmin">
            <div class="sm:col-span-5">
              <div class="relative">
                <div class="absolute inset-0 flex items-center" aria-hidden="true">
                  <div class="w-full border-t border-gray-300" />
                </div>
                <div class="relative flex justify-start">
                  <span class="bg-white pr-3 text-base font-semibold leading-6 text-gray-900">Account Information</span>
                </div>
              </div>
            </div>
          </div>

          <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

            <div class="sm:col-span-5">
              <label for="account" class="block text-sm font-medium leading-6 text-gray-900">
                Account
                <span class="text-red-600 text-sm">*</span>
              </label>
              <div class="mt-2">
                <Field
                    name="account"
                    v-model="formData.account_id"
                    v-slot="{ componentField }">
                  <v-select
                      v-bind="componentField"
                      :reduce="item => item.id"
                      :options="accountList"
                      :clearable="false"
                      label="name"
                  />
                </Field>

                <ErrorMessage
                    class="mt-2 text-xs text-red-600"
                    name="account" />
              </div>
            </div>

            <div class="sm:col-span-5">
              <label for="account_role" class="block text-sm font-medium leading-6 text-gray-900">
                Account Role
              </label>
              <div class="mt-2">
                <Field
                    name="account_role"
                    v-model="formData.account_role"
                    v-slot="{ componentField }">
                  <v-select
                      v-bind="componentField"
                      :reduce="item => item.value"
                      :options="accountRolesList"
                      :clearable="false"
                      label="key"/>
                </Field>

                <ErrorMessage
                    class="mt-2 text-xs text-red-600"
                    name="account_role" />
              </div>
            </div>

          </div>

          <div v-if="isAdmin">
            <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6 mt-12 mb-2">
              <div class="sm:col-span-5">
                <div class="relative">
                  <div class="absolute inset-0 flex items-center" aria-hidden="true">
                    <div class="w-full border-t border-gray-300" />
                  </div>
                  <div class="relative flex justify-start">
                    <span class="bg-white pr-3 text-base font-semibold leading-6 text-gray-900">Payment Information</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

              <div class="sm:col-span-5">
                <label for="payment_system" class="block text-sm font-medium leading-6 text-gray-900">
                  Payment System
                </label>
                <div class="mt-2">
                  <Field
                      name="payment_system"
                      v-model="formData.payment_system"
                      v-slot="{ componentField }">
                    <v-select
                        v-bind="componentField"
                        :reduce="item => item.value"
                        :options="paymentSystemsList"
                        :clearable="false"
                        label="key"/>
                  </Field>

                  <ErrorMessage
                      class="mt-2 text-xs text-red-600"
                      name="payment_system" />
                </div>
              </div>

              <div class="sm:col-span-5">
                <label for="stripe_id" class="block text-sm font-medium leading-6 text-gray-900">
                  Stripe ID
                </label>
                <div class="mt-2">
                  <Field
                      v-model="formData.stripe_id"
                      v-bind:class="{ 'ring-red-600': errors.stripe_id }"
                      type="text"
                      name="stripe_id"
                      id="stripe_id"
                      placeholder="Stripe id"
                      class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      :disabled="formData.payment_system === 'manual'"/>

                  <ErrorMessage class="mt-2 text-xs text-red-600" name="stripe_id" />
                </div>
              </div>

              <div class="sm:col-span-5">
                <label for="pm_type" class="block text-sm font-medium leading-6 text-gray-900">
                  Card brand
                </label>
                <div class="mt-2">
                  <Field
                      v-model="formData.pm_type"
                      v-bind:class="{ 'ring-red-600': errors.pm_type }"
                      type="text"
                      name="pm_type"
                      id="pm_type"
                      placeholder="Card brand"
                      class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      :disabled="formData.payment_system === 'manual'" />

                  <ErrorMessage class="mt-2 text-xs text-red-600" name="pm_type" />
                </div>
              </div>

              <div class="sm:col-span-5">
                <label for="pm_last_four" class="block text-sm font-medium leading-6 text-gray-900">
                  Card last four
                </label>
                <div class="mt-2">
                  <Field
                      v-model="formData.pm_last_four"
                      v-bind:class="{ 'ring-red-600': errors.pm_last_four }"
                      type="text"
                      name="pm_last_four"
                      id="pm_last_four"
                      placeholder="Card last four"
                      class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      :disabled="formData.payment_system === 'manual'" />

                  <ErrorMessage class="mt-2 text-xs text-red-600" name="pm_last_four" />
                </div>
              </div>

              <div class="sm:col-span-5">
                <label for="trial_ends_at" class="block text-sm font-medium leading-6 text-gray-900">
                  Trial ends at
                </label>
                <div class="mt-2">
                  <vue-tailwind-datepicker
                      :formatter="formatter"
                      v-model="formData.trial_ends_at"
                      as-single />

                  <ErrorMessage
                      class="mt-2 text-xs text-red-600"
                      name="trial_ends_at" />
                </div>
              </div>

            </div>
          </div>

        </div>
        <div class="flex items-center justify-end gap-x-6 border-t border-gray-900/10 px-4 py-4 sm:px-8">
          <button @click="cancel" type="button" class="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
          <button v-if="userId" @click="handleSubmit($event, update)" type="button" class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Update</button>
          <button v-else @click="handleSubmit($event, create)" type="button" class="rounded-md bg-gray-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600">Save</button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script>
import { TrashIcon } from '@heroicons/vue/24/solid'
import TrixComponent from "../TrixComponent.vue";

export default {
  name: "UserCreateEditFormComponent",

  props: {
    userId: {
      type: Number,
      required: false,
    },
    accountId: {
      type: Number,
      required: false,
    },
  },
  data() {
    return {
      accountList: [],
      accountRolesList: [],
      paymentSystemsList: [],
      formData: {
        first_name: null,
        last_name: null,
        email: null,
        password: null,
        account_id: this.accountId,
        account_role: null,
        //payment
        payment_system: 'manual',
        stripe_id: null,
        pm_type: null,
        pm_last_four: null,
        trial_ends_at: '',
        profile_photo: null,
      },
      formatter: {
        date: 'YYYY-MM-DD HH:mm:ss',
        month: 'MMM'
      },
      dateValue: [],
      previewImage: null
    }
  },
  components: {
    TrixComponent,
    TrashIcon,
  },
  computed: {
    schema() {
      let validator = yup.object({
        first_name: yup.string().required().min(3).label('First Name'),
        last_name: yup.string().required().min(3).label('Last Name'),
        email: yup.string().required().email().label('Email'),
        password: yup.string().required().min(8).label('Password'),
        account: yup.number().required().label('Account'),
        account_role: yup.string().nullable().label('Account role'),
      });

      if (this.isAdmin) {
        validator = validator.shape({
          payment_system: yup.string().nullable().min(3).label('Payment system'),
          stripe_id: yup.string().nullable().min(3).label('Stripe ID'),
          pm_type: yup.string().nullable().min(3).label('Card brand'),
          pm_last_four: yup.string().nullable().min(3).label('Card last four'),
          trial_ends_at: yup.date().nullable().label('Trial ends at'),
        });
      }

      if (this.userId) {
        validator = validator.shape({
          password: yup.string().nullable().min(8).label('Password'),
        });
      }

      return validator;
    },
    isAdmin() {
      return this.$store.state.userIsAccountLevelAdmin;
    },
  },
  methods: {
    getPaymentSystemsList() {
      axios.get(`/member-firm/user/form-data/payment-systems-list`).then((res) => {
        this.paymentSystemsList = Object.entries(res.data.payment_systems).map(([key, value]) => ({ key, value }));
      }).catch((error) => {
        console.log('error', error)
      })
    },
    getAccountRolesList() {
        axios.get(`/member-firm/user/form-data/account-roles-list`).then((res) => {
        this.accountRolesList = Object.entries(res.data.account_roles).map(([key, value]) => ({ key, value }));
      }).catch((error) => {
        console.log('error', error)
      })
    },
    getAccountsList() {
      axios.get(`/member-firm/user/form-data/accounts-list`).then((res) => {
        this.accountList = res.data.data;
      }).catch((error) => {
        console.log('error', error)
      })
    },
    getUser() {
      axios.get(`/member-firm/users/edit/${this.userId}`).then((res) => {
        this.formData = res.data.data;
        // for admin
        if (this.isAdmin) {

        }
      }).catch((error) => {
        console.log('error', error)
      })
    },
    update() {
      axios.post(
          `/member-firm/users/update/${this.userId}`,
          this.formData,
          {
            headers: {'Content-Type': 'multipart/form-data'},
            params: {_method: 'PUT'}
          }
      ).then((res) => {
            this.$emit('reloadIndex');
            this.$notify({ type: "success", title: "Successfully", text: res.data.message });
            this.$emit('cancel');
      }).catch((error) => {
            console.log('error', error);
            this.$emit('reloadIndex');
            this.$notify({ title: "Unsuccessfully", text: error.message });
      });
    },
    create() {
      axios.post(
          `/member-firm/users/store`,
          this.formData,
          {headers: {'Content-Type': 'multipart/form-data'}}
      ).then((res) => {
            this.$emit('reloadIndex');
            this.$notify({ type: "success", title: "Successfully", text: res.data.message });
            this.$emit('cancel');
      }).catch((error) => {
            console.log('error', error);
            this.$emit('reloadIndex');
            this.$notify({ title: "Unsuccessfully", text: error.message });
      });
    },
    cancel() {
      this.$emit('cancel');
    },
    destroy() {
      if(confirm("Do you really want to delete?")) {
        axios.delete(`/member-firm/users/destroy/${this.userId}`).then((res) => {
          this.$emit('cancel');
          this.$emit('reloadIndex');
          this.$notify({ type: "success", title: "Successfully", text: res.data.message });
        }).catch((error) => {
          console.log('error', error)
          this.$notify({ title: "Unsuccessfully", text: error.message });
          this.$emit('reloadIndex');
        })
      }
    },
    handleProfilePhotoChange() {
      const fileInput = this.$refs.profilePhotoInput;

      if (fileInput.files.length > 0) {
        this.formData.profile_photo = fileInput.files[0];

        if (this.formData.profile_photo) {
          let reader = new FileReader
          reader.onload = e => {
            this.previewImage = e.target.result
          }
          reader.readAsDataURL(this.formData.profile_photo)
          this.$emit('input', this.formData.profile_photo)
        }
        console.log(this.formData);
      }
    },
    selectProfilePhoto() {
      const fileInput = this.$refs.profilePhotoInput;
      if (fileInput) {
        fileInput.click();
      }
    },
  },
  created() {
    if(this.userId){
      this.getUser();
    } else {
      // for admin
      if (this.isAdmin) {

      }
    }
    this.getAccountsList();
    this.getAccountRolesList();
    this.getPaymentSystemsList();
  }
}
</script>

<style scoped>
  /*@import 'vue-select/dist/vue-select.css';*/
</style>